/*
  A collection of utilities for dealing with browser identification
*/

export function getAgent() {
  return navigator.userAgent.toLocaleLowerCase();
}

export function isTouchDevice() {
  return (/(iphone|ipod|ipad|android|iemobile|blackberry|bada)/).test(getAgent());
}

export function iPhone() {
  return getAgent().includes('iphone');
}


export default {
  getAgent,
  iPhone,
  isTouchDevice,
};
